import { connect } from 'react-redux';

import { getIsHotelOnly, searchTypeSelector } from 'src/store/view/selectors';
import { isMapViewSelector } from '../../store/map/selectors';
import { getBrowser } from '../../selectors/browser';

import { hotelsCountSelector } from '../../store/hotels/selectors';

import { isEmptySearchSelector } from '../../store/emptySearch/selectors';
import {
  firstResultsFetchedSelector,
  isAwaitingFiltration,
} from '../../searchStatus/selectors';
import SearchPageHeader from './SearchPageHeader';

const mapStateToProps = (state) => ({
  firstResultsFetched: firstResultsFetchedSelector(state),
  fullMapView: isMapViewSelector(state),
  browser: getBrowser(state),
  searchType: searchTypeSelector(state),
  hotelsCount: hotelsCountSelector(state),
  isEmptySearch: isEmptySearchSelector(state),
  isHotelOnly: getIsHotelOnly(state),
  awaitFiltration: isAwaitingFiltration(state),
});

export default connect(mapStateToProps)(SearchPageHeader);
